import { useSearchParams } from "react-router-dom";
import ModalComponent from "../../../../components/modals/ModalFormComponent";
import { useGetLeavePlanById } from "../../../../services/leave-plan.service";
import { getDaysBetweenDates } from "../data";
import { SkewLoader } from "react-spinners";

type LeavePlanDetailsModalProps = {
	open: boolean;
	setOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

const LeavePlanDetailsModal = ({ open, setOpen }: LeavePlanDetailsModalProps) => {
	const [searchParams] = useSearchParams();
    const requestId = searchParams.get("id");

	const { data: leavePlanData, isLoading } = useGetLeavePlanById(Number(requestId));

	return (
		<ModalComponent
			open={open}
			title={"Leave Plan Details"}
			width={660}
			handleClose={() => setOpen(false)}
		>
			{isLoading ? (
				<div className="text-center py-10">
					<SkewLoader color="#F58B00" />
				</div>
			):(
				<div className="text-charcoal">
					<section className="flex items-start justify-between mt-3">
						<div>
							<h2 className="text-se text-gray-500 text-2xs">Employee</h2>
							<p className="text-2sm">
								{(leavePlanData?.data?.employee?.firstName || "") + " "}
								{leavePlanData?.data?.employee?.lastName || ""}
							</p>
						</div>
					</section>
					<section className="flex items-start justify-between mt-6">
						<div>
							<h2 className="text-se text-gray-500 text-2xs">Leave Type</h2>
							<div
								className="relative rounded-lg px-3 py-2 inline-flex overflow-hidden"
								style={{ color: leavePlanData?.data?.leavePackage?.leaveType?.colorCode }}
							>
								<div 
									className="absolute inset-0" 
									style={{ 
										background: leavePlanData?.data?.leavePackage?.leaveType?.colorCode, 
										opacity: "15%"
									}}
								/>
								<p className="text-xs">{leavePlanData?.data?.leavePackage?.leaveType?.name}</p>
							</div>
						</div>
					</section>
					<section className="mt-6">
						<h2 className="text-se text-gray-500 text-2xs">Comment</h2>
						<p className="text-2sm">
							{leavePlanData?.data?.comment || ""}
						</p>
					</section>
					<section className="flex items-start justify-between mt-6">
						<div>
							<h2 className="text-se text-gray-500 text-2xs">Last Modified At</h2>
							<p className="text-2sm">
								{new Date((leavePlanData?.data?.createdAt || leavePlanData?.data?.modifiedAt) as string).toLocaleDateString("en-US", { 
									month: "short", day: "numeric", year: "numeric" 
								})}
							</p>
						</div>
						<div className="flex flex-col items-end">
							<h2 className="text-se text-gray-500 text-2xs">No. of Days</h2>
							<p className="text-2sm">
								{getDaysBetweenDates(leavePlanData?.data?.intendedStartDate, leavePlanData?.data?.intendedReturnDate)}
							</p>
						</div>
					</section>
					<section className="flex items-start justify-between mt-6 pb-5">
						<div>
							<h2 className="text-se text-gray-500 text-2xs">Intended Start Date</h2>
							<p className="text-2sm">
								{new Date(leavePlanData?.data?.intendedStartDate as string).toLocaleDateString("en-US", { 
									month: "short", day: "numeric", year: "numeric" 
								})}
							</p>
						</div>
						<div>
							<h2 className="text-se text-gray-500 text-2xs">Intended End Date</h2>
							<p className="text-2sm">
								{new Date(leavePlanData?.data?.intendedReturnDate as string).toLocaleDateString("en-US", { 
									month: "short", day: "numeric", year: "numeric" 
								})}
							</p>
						</div>
					</section>
				</div>
			)}
		</ModalComponent>
	);
};

export default LeavePlanDetailsModal;
